
import { Project } from "../../classes"

const ProjectModule = {
  namespaced: true,
  state: () => ({
    project: null,
    isLoading: false
  }),
  actions: {
    getProject: async ({ commit }, payload) => {
      try {
        commit("setProject", null);
        commit("setIsLoading", true);
        const data = await Project.getProject(payload);
        commit("setProject", data);
        commit("setIsLoading", false);
        return data;
      } catch (err) {
        commit("setIsLoading", false);
        return error;
      }
    }
  },
  getters: {
    getProject: state => state.project,
    getIsLoading: state => state.isLoading,
  },
  mutations: {
    clearProject: (state) => {
      state.project = null;
      state.isLoading = false;
    },
    setProject: (state, project) => {
      state.project = project;
    },
    setIsLoading: (state, isLoading) => {
      state.isLoading = isLoading;
    },
  },
};
export default ProjectModule;
